import { useQuery } from 'react-query';
import attendance from 'api/attendance';
import { buildFormState } from '../utils';

export const ATTENDANCE_SETTINGS_QUERY_KEY = 'attendance-settings';

export function useAttendanceSettings() {
  return useQuery({
    queryKey: [ATTENDANCE_SETTINGS_QUERY_KEY],
    queryFn: () => attendance.fetchAttendanceSettings(),
    select: (response) => buildFormState(response.data),
  });
}
